// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svc-tab-designer{background-color:#eaecf4}`, "",{"version":3,"sources":["webpack://./ClientApp/components/survey/creator/Creator/TabSurveys.vue"],"names":[],"mappings":"AACA,kBACE,wBAAA","sourcesContent":["\r\n.svc-tab-designer {\r\n  background-color: #eaecf4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
